import { useSearchParams } from "react-router";
import { AnalyticsParamsBag } from "./AnalyticsParamsBag.ts";

export function useAnalyticsParams(): {
  analyticsParams: AnalyticsParamsBag;
} {
  const [searchParams] = useSearchParams();
  const utmSource = searchParams.get("utm_source") ?? undefined;
  const utmMedium = searchParams.get("utm_medium") ?? undefined;
  const utmCampaign = searchParams.get("utm_campaign") ?? undefined;
  const utmTerm = searchParams.get("utm_term") ?? undefined;
  const utmContent = searchParams.get("utm_content") ?? undefined;

  return {
    analyticsParams: {
      utmCampaign,
      utmContent,
      utmMedium,
      utmSource,
      utmTerm,
    },
  };
}
